import Env from 'Env';

/**
 * Types of labels
 * @enum
 */
const Label = {
  RESET_PIN: 'Reset PIN Request',
  UPDATE_PIN: 'Update PIN',
  MAKE_PAYMENT: 'Make a payment',
  UPDATE_PAYMENT: 'Update payment details',
  UPDATE_STATUS: 'Update Status',
  ACTIVATE_CARD: 'Activate Card',
  TRANSFER_CARD: 'Transfer Card',
  UPDATE_USAGE: 'Update Usage',
  EDIT_CARD: 'Edit Card',

  ACTIVATE_CARD_MSG: 'Are you sure you want to activate this card?',
  ACTIVATE_MULTIPLE_CARD_MSG: 'Are you sure you want to activate the inactive cards?',

  LOADING: 'Loading...',

  CASH_COURIER_TOOLTIP: 'Courier cannot be delivered to PO Box. Please check the address before placing the order.',

  // AC1 (DW-146): When Way4 is ON the phone support line is removed from the banner.
  // When Way4 is OFF (old behaviour) the phone number is still shown.
  // Evaluated lazily on each access so the feature flag is read at call time.
  get EV_CHARGING_ENABLED_NOTIFICATION() {
    const isEvWay4 = typeof Env.getIsEvWay4Enabled === 'function' ? Env.getIsEvWay4Enabled() : false;
    if (isEvWay4) {
      return 'This AmpolCard is enabled for EV charging.';
    }
    const phone = typeof Env.getCustomerServicePhone === 'function' ? Env.getCustomerServicePhone() : null;
    return phone
      ? `This AmpolCard is enabled for EV charging. For support, please call ${phone}.`
      : 'This AmpolCard is enabled for EV charging.';
  },
  EV_CHARGING_PIN_MANAGEMENT_NOTIFICATION:
    'PIN management applies to fuel and convenience products only. Not applicable to EV chargers.',
  EV_CHARGING_TRANSACTIONS_NOTIFICATION:
    'Transactions displayed are fuel and convenience purchases only. EV charging sessions are not shown.',
  EV_CHARGING_REISSUE_NOTIFICATION: 'Please wait for your new card to use AmpCharge EV Charging.',
};

export default Label;
